/**
 * @generated SignedSource<<612b7f2e9b6587c3a0804d275485b8e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReturnPolicy_user" | "PdpSharedDetailShipping_user">;
  readonly " $fragmentType": "PdpRespShippingReturns_user";
};
export type PdpRespShippingReturns_user$key = {
  readonly " $data"?: PdpRespShippingReturns_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7d428a20f9f9e346c0ec8f25f0ed943e";

export default node;
